export default {"src":"/_next/static/media/faq-arrow.9abbe089.svg","height":21,"width":26,"blurWidth":0,"blurHeight":0};